import I18n from 'I18n';
export function insertCatchUpTabPrototype(location) {
  return Object.assign({}, location, {
    container: Object.assign({}, location.container, {
      contents: [{
        type: 'CONTAINER',
        id: '3',
        label: I18n.text('catchUpTab.label'),
        layout: {
          type: 'LIST'
        },
        contents: [{
          type: 'CONTAINER',
          id: '4',
          label: I18n.text('catchUpTab.sections.overview'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'company-description-card',
              cardTitle: I18n.text('catchUpTab.cards.description'),
              cardType: 'COMPANY_DESCRIPTION'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'recent-interactions-card',
              cardTitle: I18n.text('catchUpTab.cards.recentInteractions'),
              cardType: 'RECENT_INTERACTIONS'
            },
            configuration: {}
          }]
        }, {
          type: 'CONTAINER',
          id: '5',
          label: I18n.text('catchUpTab.sections.featuredAssociations'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'featured-deal-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredDeal'),
              cardType: 'FEATURED_DEAL'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'featured-contact-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredContact'),
              cardType: 'FEATURED_CONTACT'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'featured-ticket-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredTicket'),
              cardType: 'FEATURED_TICKET'
            },
            configuration: {}
          }]
        }, {
          type: 'CONTAINER',
          id: '7',
          label: I18n.text('catchUpTab.sections.health'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'sentiment-card',
              cardTitle: I18n.text('catchUpTab.cards.sentiment'),
              cardType: 'SENTIMENT'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'challenges-pain-points-card',
              cardTitle: I18n.text('catchUpTab.cards.challenges'),
              cardType: 'CHALLENGES_PAIN_POINTS'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'customer-tidbits-card',
              cardTitle: I18n.text('catchUpTab.cards.positiveFeedback'),
              cardType: 'CUSTOMER_TIDBITS'
            },
            configuration: {}
          }]
        }]
      }, ...location.container.contents]
    })
  });
}
export function insertCatchUpTabPrototypeM2(location) {
  return Object.assign({}, location, {
    container: Object.assign({}, location.container, {
      contents: [{
        type: 'CONTAINER',
        id: '3',
        label: I18n.text('catchUpTab.label'),
        layout: {
          type: 'LIST'
        },
        contents: [{
          type: 'CONTAINER',
          id: '4',
          label: I18n.text('catchUpTab.sections.overview'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'company-description-card',
              cardTitle: I18n.text('catchUpTab.cards.description'),
              cardType: 'COMPANY_DESCRIPTION'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'recent-interactions-card',
              cardTitle: I18n.text('catchUpTab.cards.recentInteractions'),
              cardType: 'RECENT_INTERACTIONS'
            },
            configuration: {}
          }]
        }, {
          type: 'CONTAINER',
          id: '5',
          label: I18n.text('catchUpTab.sections.featuredAssociations'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'featured-deal-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredDeal'),
              cardType: 'FEATURED_DEAL'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'featured-contact-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredContact'),
              cardType: 'FEATURED_CONTACT'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'featured-ticket-card',
              cardTitle: I18n.text('catchUpTab.cards.featuredTicket'),
              cardType: 'FEATURED_TICKET'
            },
            configuration: {}
          }]
        }, {
          type: 'CONTAINER',
          id: '7',
          label: I18n.text('catchUpTab.sections.health'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'sentiment-card',
              cardTitle: I18n.text('catchUpTab.cards.sentiment'),
              cardType: 'SENTIMENT'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'challenges-pain-points-card',
              cardTitle: I18n.text('catchUpTab.cards.challenges'),
              cardType: 'CHALLENGES_PAIN_POINTS'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'customer-tidbits-card',
              cardTitle: I18n.text('catchUpTab.cards.positiveFeedback'),
              cardType: 'CUSTOMER_TIDBITS'
            },
            configuration: {}
          }]
        }, {
          type: 'CONTAINER',
          id: '8',
          label: I18n.text('catchUpTab.sections.dataQuality'),
          layout: {
            type: 'GRID',
            collapsible: true
          },
          contents: [{
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 12
            },
            definition: {
              cardId: 'formatting-issues-card',
              cardTitle: I18n.text('catchUpTab.cards.formattingIssues'),
              cardType: 'FORMATTING_ISSUES'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'missing-properties-card',
              cardTitle: I18n.text('catchUpTab.cards.missingProperties'),
              cardType: 'MISSING_PROPERTIES'
            },
            configuration: {}
          }, {
            type: 'CARD',
            layout: {
              type: 'CARD',
              widthInGrid: 6
            },
            definition: {
              cardId: 'duplicate-records-card',
              cardTitle: I18n.text('catchUpTab.cards.duplicateRecords'),
              cardType: 'DUPLICATE_RECORDS'
            },
            configuration: {}
          }]
        }]
      }, ...location.container.contents]
    })
  });
}